import { render, staticRenderFns } from "./Form.vue?vue&type=template&id=0a368f77&"
import script from "./Form.vue?vue&type=script&lang=js&"
export * from "./Form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/otavio.cardoso.neto/Workspace/securamdata/sca-app-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0a368f77')) {
      api.createRecord('0a368f77', component.options)
    } else {
      api.reload('0a368f77', component.options)
    }
    module.hot.accept("./Form.vue?vue&type=template&id=0a368f77&", function () {
      api.rerender('0a368f77', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/apps/newsletter/Form.vue"
export default component.exports